<div class="row mb-3">
    <div class="col-md-8">
        <h3>{{pageTitle}}</h3>
    </div>
    <div class="col-md-4">
        <span class="float-right ml-auto">
            <button class="btn btn-default" type="button" *ngIf="isPermissionExists" (click)="addCVSMapping();">
                Add CVS Mapping
            </button>
        </span>

    </div>
</div>

<div class="cvs-mapping-page">
    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="mappingDataSource && mappingDataSource.data.length === 0"> {{ "Label.cvs_mapping_not_available" | translate}}</div>
        <div class="col-md-12 mt-3" *ngIf="mappingDataSource && mappingDataSource.data.length >0">

            <!-- Material Table -->
            <table aria-labelledby="mapping" aria-describedby="mapping" mat-table [dataSource]="mappingDataSource" matSort class="col-md-12 mat-elevation-z8">
                <th id="cvs-mapping-header" style="display:none;">Manage CVS-Mapping</th>
                <ng-container class="ml-2" matColumnDef="capability">
                    <th id="cvs-mapping" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> CVS Mapping </th>
                    <td mat-cell *matCellDef="let element"> {{element.capability}} </td>
                </ng-container>
                <ng-container matColumnDef="internal">
                    <th id="cvs-internal" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Internal </th>
                    <td mat-cell *matCellDef="let element">
                        <div *ngFor="let isp of element.internal">{{isp}}</div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="external">
                    <th id="cvs-external" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> External </th>
                    <td mat-cell *matCellDef="let element">
                        <div *ngFor="let esp of element.external">{{esp}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action" *ngIf="isPermissionExists">
                    <th id="cvs-action" class="resource-header-card" mat-header-cell *matHeaderCellDef>Action </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="action-control col-md-1">
                            <a matTooltip="Click to Edit" class="action-control-delete cursor-pointer" (click)="onEdit(row);">
                                <img alt="Edit" [src]="commonService.commonFiles['edit']">
                            </a>
                        </span>
                        <span class="action-control col-md-1">
                            <a matTooltip="Click to Delete" class="action-control-delete cursor-pointer" (click)="onDelete(row);">
                                <img alt="Delete" [src]="commonService.commonFiles['delete']">
                            </a>
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>